import { createRef, useState, useEffect, Fragment } from "react";
import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { StateMachineProvider, createStore } from "little-state-machine";
import { Button } from "@components/Button";
import { Media } from "./Media";
import { Section } from "./Section";
import { MobileSection } from "./Mobile/MobileSection";
import { SimpleBlockContent } from "../../SimpleBlockContent";
import styles from "./styles/bundle.module.css";

createStore({ disabled: false });

const MOBILE_BREAKPOINT = 768;

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function BundleView({ bundle }) {
  const { t } = useTranslation("bundles");
  const [width, setWidth] = useState();

  useEffect(() => {
    const { width } = getWindowDimensions();
    if (width) setWidth(width);
  }, []);

  if (!bundle.sections || bundle.sections.length === 0) {
    return null;
  }

  const refs = bundle.sections.reduce((acc, value) => {
    acc[value.key] = createRef();
    return acc;
  }, {});

  const handleScrollTo = (key) => {
    refs[key].current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  };

  const Images = () => {
    return (
      <section className={styles.images}>
        {bundle.images.map((mediaSrc) => (
          <Media src={mediaSrc} key={mediaSrc._key} />
        ))}
      </section>
    );
  };

  return (
    <>
      <section className={styles.container}>
        {width > MOBILE_BREAKPOINT && <Images />}

        <section className={styles.detailsContainer}>
          <div className={styles.details}>
            <h1 className={styles.title}>{bundle.title}</h1>
            {width <= MOBILE_BREAKPOINT && <Images />}
            {bundle.description && <SimpleBlockContent blocks={bundle.description} />}
          </div>

          <div className={styles.footer}>
            <Button
              handleClick={() => handleScrollTo(bundle.sections[0].key)}
              description="addFirstProduct"
              descriptionText="Click to scroll to first product"
            >
              {bundle.bundleType === "stock-up" ? t("first-button-bundle") : t("first-button-set")}
            </Button>
          </div>
        </section>
      </section>
      <StateMachineProvider>
        <section className={styles.sections}>
          {bundle.sections.map((section, index) => {
            return (
              <Fragment key={section.key}>
                {width > MOBILE_BREAKPOINT && (
                  <Section
                    sections={bundle.sections}
                    section={section}
                    index={index}
                    ref={refs[section.key]}
                    handleScrollTo={handleScrollTo}
                    discountMessage={bundle.discountMessage}
                    isStockup={bundle.bundleType === "stock-up"}
                    slug={bundle.slug.current}
                    width={width}
                  />
                )}
                {width <= MOBILE_BREAKPOINT && (
                  <MobileSection
                    sections={bundle.sections}
                    section={section}
                    index={index}
                    ref={refs[section.key]}
                    handleScrollTo={handleScrollTo}
                    discountMessage={bundle.discountMessage}
                    isStockup={bundle.bundleType === "stock-up"}
                    slug={bundle.slug.current}
                  />
                )}
              </Fragment>
            );
          })}
        </section>
      </StateMachineProvider>
    </>
  );
}

BundleView.propTypes = { bundle: PropTypes.object.isRequired };
